import React from "react";

const About = () => {
    return (
        <h1>About Us</h1>
    );
}

export default About;